import { BASE_URL, HTTP_OK, HTTP_STATUS_SUCCESS, SIGNIN_ENDPOINT } from "../../utils/constants";
import { getBaseUrl } from "../../utils/utils";
import { signInBegin, signInFailure, signInSuccess } from "../auth";
import { apiPost } from "./api";

export const signin = (payload) => async (dispatch, getState) => {
	await dispatch(signInBegin());

	try {
		const { status, data } = await dispatch(
			apiPost(`${getBaseUrl()}${SIGNIN_ENDPOINT}`, {
				body: payload,
			})
		);

		if (status === HTTP_OK) {
			const response = data || false;

			if (response.status === HTTP_STATUS_SUCCESS) {
				await dispatch(signInSuccess({ data, status }));

				return true;
			} else {
				await dispatch(signInFailure({ message: JSON.stringify(status), status }));

				return false;
			}
		}
	} catch (e) {
		await dispatch(signInFailure({ message: JSON.stringify(e) }));

		return false;
	}
};
